/** Дата создания интеграции: ISO-строка или Unix ms/сек (число). */
export function parseConnectorIntegrationDate(raw: unknown): Date | null {
  if (raw == null || raw === '') return null;
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const ms = raw < 1e12 ? raw * 1000 : raw;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  if (typeof raw === 'string') {
    if (/^\d+$/.test(raw)) {
      const n = Number(raw);
      const ms = n < 1e12 ? n * 1000 : n;
      const d = new Date(ms);
      return Number.isNaN(d.getTime()) ? null : d;
    }
    const d = new Date(raw);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

export function formatConnectorIntegrationCreatedAt(raw: unknown): string {
  const d = parseConnectorIntegrationDate(raw);
  return d ? d.toLocaleString() : '-';
}

/**
 * Сводит ответ GET integration (обёртка success/data, вложенный data, camelCase) в один плоский слой для UI.
 */
export function mergeIntegrationDetailLayers(raw: unknown): Record<string, unknown> {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const r = raw as Record<string, unknown>;
  const d = r.data;
  const L1 =
    d !== null && typeof d === 'object' && !Array.isArray(d) ? (d as Record<string, unknown>) : {};
  const d2 = L1.data;
  const L2 =
    d2 !== null && typeof d2 === 'object' && !Array.isArray(d2) ? (d2 as Record<string, unknown>) : {};
  return { ...r, ...L1, ...L2 };
}

export function pickIntegrationApiKey(merged: Record<string, unknown>): string | null {
  for (const k of ['apikey', 'apiKey', 'api_key', 'API_KEY'] as const) {
    const v = merged[k];
    if (v != null && String(v).trim() !== '') return String(v);
  }
  return null;
}

/** Подпись «Created by»: имя/email с бэка или owner_id из control API. */
export function getConnectorIntegrationCreatedByDisplay(it: {
  created_by_name?: string;
  created_by_email?: string;
  owner_id?: string;
  ownerId?: string;
  user_id?: string;
  created_by_id?: string;
  created_by_user_id?: string;
}): { text: string; title: string; full: string } {
  const name = typeof it?.created_by_name === 'string' ? it.created_by_name.trim() : '';
  const email = typeof it?.created_by_email === 'string' ? it.created_by_email.trim() : '';
  if (name) {
    const full = email ? `${name} (${email})` : name;
    return { text: name, title: full, full };
  }
  if (email) return { text: email, title: email, full: email };

  const owner =
    it?.owner_id ?? it?.ownerId ?? it?.user_id ?? it?.created_by_id ?? it?.created_by_user_id;
  if (owner != null && String(owner).trim() !== '') {
    const full = String(owner).trim();
    const short = full.length > 20 ? `${full.slice(0, 8)}…${full.slice(-6)}` : full;
    return { text: short, title: full, full };
  }
  return { text: '-', title: '', full: '-' };
}
